import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_TRADING_ENGINE + "CompanyWhitelist/";
const delegatedEndpoint = apiEndpoint + "Delegated/";

export async function getCompanyWhitelists() {
  const { data } = await http.get(apiEndpoint);
  return data;
}

export async function getCompanyWhitelist(organizationId) {
  const { data } = await http.get(apiEndpoint + organizationId);
  return data;
}

export async function saveCompanyWhitelist(organizationId, companyWhitelistPolicy) {
  const { data } = await http.put(apiEndpoint + organizationId, companyWhitelistPolicy);
  return data;
}

export async function saveCompanyWhitelistsBulk(companyWhitelistPolicies) {
  const { data } = await http.put(apiEndpoint + "Bulk", companyWhitelistPolicies);
  return data;
}

export async function getDelegatedCompanyWhitelists() {
  const { data } = await http.get(delegatedEndpoint);
  return data;
}

export async function getDelegatedCompanyWhitelist(organizationId) {
  const { data } = await http.get(delegatedEndpoint + organizationId);
  return data;
}

export async function saveDelegatedCompanyWhitelist(organizationId, companyWhitelistPolicy) {
  const { data } = await http.put(delegatedEndpoint + organizationId, companyWhitelistPolicy);
  return data;
}
